

/* Backend generic calls */

export function callJSONFiles(url: string, method: string, success?: (response: any) => void, error?: (e: Response) => void) {
    fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        mode: 'cors',
        cache: 'no-cache'
    }).then((res) => {
        if (res) {
            res.json().then((j) => {
                success && success(j)
            })
        } else {
            console.error(res)
            error && error(res)
        }
    }).catch((e) => {
        console.error(e)
        error && error(e)
    })
}